import { withRouter } from 'react-router-dom';
import { Box, Typography, Grid, FormHelperText } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import BariatricsIcon from '../../../images/BariatricsIcon.png'
import styles from './Bariatrics.style';
import { useTranslation } from 'react-i18next';
import { MobileRegularPage } from '../../../components';
import { SelectRadioInput } from '../../desktop/patient/ProviderInputComponents';
import { useEffect, useState } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import mainTheme from '../../../themes/mainTheme';

const FirstStep = (props) => {
    const classes = styles();
    const { t } = useTranslation();
    const [autoUpdate, setAutoUpdate] = useState(false);

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
      }, [
        props.hereForBariatricsOrWeightManagement,
        props.hereForBariatricCare,
        props.submitted
      ]);

    return (
        <MobileRegularPage>
            <Box className={classes.title}>
                <Box>
                    <img src={BariatricsIcon} style={{width:'100px', height:'100px'}} />
                </Box>
                <Typography variant="h4" style={{ marginBottom: "30px", fontWeight: '550' }}>
                 Bariatric Care
                </Typography>
                <Grid item xs={12}>
                    {/* Bariatric care */}
                    <Typography gutterBottom>Are you here due to Bariatric Care?*</Typography>
                    <FormControl
                        component="fieldset"
                        error={props.submitted && !props.validator.fieldValid('hereForBariatricCare')}
                    >
                        <RadioGroup row
                            aria-label="Bariatric care"
                            value={props.hereForBariatricCare}
                            onChange={props.setHereForBariatricCare}
                        >
                            {["Yes", "No", "Unsure"].map((answer, i) =>
                                <FormControlLabel key={i} value={answer} control={<Radio  sx={{        
                                    '&.Mui-checked': {
                                      color: mainTheme.palette.primary.main,
                                    },
                                  }}  color="primary" />} label={answer} />
                            )}
                        </RadioGroup>
                        <FormHelperText  style={{color:'red',
            }}>
                            {props.validator.message('hereForBariatricCare', props.hereForBariatricCare, 'required')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                {props.hereForBariatricCare && props.hereForBariatricCare ==="Yes" &&
                <Grid item xs={12} style={{ marginBottom: 10 }}>
                    <Typography style={{ marginBottom: 10 }} gutterBottom>
                        Are you here for a bariatric surgery or weight management?{
                            <span
                                className={
                                    props.error && !props.validator.fieldValid("hereForBariatricsOrWeightManagement")
                                        ? classes.asteriskError
                                        : classes.asteriskNormal
                                }
                            >
                                *
                            </span>
                        }
                    </Typography>
                    <SelectRadioInput
                        setValue={props.handleBariatricsOrWeightManagementChange}
                        value={props.hereForBariatricsOrWeightManagement}
                        elements={["Weight management", "Bariatric surgery"]}
                        clearValues={[]}
                        error={props.error && !props.validator.fieldValid("hereForBariatricsOrWeightManagement")}
                    />
                   <FormHelperText
            style={{
              color:
                props.error &&
                !props.validator.fieldValid("hereForBariatricsOrWeightManagement") &&
                `red`,
            }}
          >
            {props.validator.message(
              "hereForBariatricsOrWeightManagement",
              props.hereForBariatricsOrWeightManagement,
              `hereForBariatricsOrWeightManagement:${props.hereForBariatricCare}`
            )}
          </FormHelperText>
                </Grid>}
            </Box>
        </MobileRegularPage>
    );
}

export default withRouter(FirstStep);
